import Navbar from '../../components/header/navBar';
import Background from '../../components/backGround/backGround';
import '../../common/styles/components/check.scss';
import { Link } from 'react-router-dom';

interface RegisterPageProps { }

const RegisterPage: React.FC<RegisterPageProps> = () => {
    return (
        <>
            <Navbar />
            <section className="info-h shrot">
                <div className="padding-global">
                    <div className="padding-section-large">
                        <div className="container-large">
                            <div className="banner_grilla">
                                <div id="w-node-_4ad00283-b912-c4f1-f6b7-5dfad8616956-9e07aa0c" className="banner_form">
                                    <div className="formulario w-form">
                                        <form id="email-form" name="email-form" data-name="Email Form" method="get" className="form" data-wf-page-id="67200ed2be39c0429e07aa0c" data-wf-element-id="221eda68-b07c-d36b-9089-84cb7aded835">
                                            <div className="title-component is-center">
                                                <h2>El documento de identidad ingresado no está registrado.</h2>
                                                <div className="line-title"></div>
                                            </div>
                                            <div className="form_txt">Regístrate para disfrutar de todos nuestros servicios  y beneficios.<br /><span className="text-color-blue"><strong>¡Es rápido y fácil!</strong></span></div>
                                            <Link to={"/actualizar-datos/acceso-a-la-cuenta"} className="button is-large is-full w-button">Afiliate</Link>
                                        </form>
                                        <div className="w-form-done">
                                            <div>Thank you! Your submission has been received!</div>
                                        </div>
                                        <div className="w-form-fail">
                                            <div>Oops! Something went wrong while submitting the form.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Background />
        </>
    );
};

export default RegisterPage;
